<template>
	<sc-table-select
	ref="tableselect"
		v-model="personvalue"
		:attrList="attrList"
		:valueList="valueList"
		:queryList="queryList"
		:orderList="orderList"
		:table-width="640"
		collapse-tags
		collapse-tags-tooltip
		:props="props"
		:selectKeyValue="selectKeyValue"
		@change="change"
	>
		<!-- collapse-tags
    collapse-tags-tooltip -->
		<template #header="{}">
			<el-form :inline="true">
				<el-row :gutter="5"
					><el-col :span="5">
						<el-input
							v-model="queryList.Code"
							placeholder="请输入编码"
							style="width: 125px"
						></el-input></el-col
					><el-col :span="5">
						<el-input
							v-model="queryList.AName"
							placeholder="请输入姓名"
							style="width: 125px"
						></el-input> </el-col
					><el-col :span="5"
						><el-input
							v-model="queryList.Mobile"
							placeholder="请输入电话"
							style="width: 125px"
						></el-input></el-col
					><el-col :span="5">
						<el-select
							v-model="queryList.State"
							placeholder="请选择状态"
							clearable
							:teleported="false"
							style="width: 125px"
						>
							<el-option label="---请选择状态---" value="" />
							<el-option label="禁用" value="0" />
							<el-option
								label="启用"
								value="1"
							/> </el-select></el-col
					><el-col :span="4">
						<el-button
							type="primary"
							@click="$refs.tableselect.getData()"
							>查询</el-button
						></el-col
					></el-row
				>
			</el-form>
		</template>
		<el-table-column
			prop="Code"
			label="编码"
			width="100"
		></el-table-column>
		<el-table-column
			prop="AName"
			label="名称"
			width="200"
		></el-table-column>
		<el-table-column
			prop="Sex"
			label="类型"
			width="120"
		></el-table-column>
		<el-table-column
			prop="Mobile"
			label="电话"
			width="120"
		></el-table-column>
		<el-table-column
			prop="State"
			label="状态"
			width="100"
		></el-table-column>
	</sc-table-select>
</template>

<script>
import tool from "@/utils/tool";
export default {
	name: "artistselect",
	data() {
		return {
			attrList: {
				//Name: "Organize",
				Name: "Person",
				UseDistinct: true,
				OrgCode: "",
				UseBackUp: false,
				UseGroup: false,
			},
			valueList: {
				Code: "Code",
				AName: "AName",
				//ParentName: "ParentName",
				Sex: "Sex",
				Mobile: "Mobile",
				State: "State",
				//PageId: "",
				//UserCode: "",
			},
			queryList: {
				Code: "",
				AName: "",
				Mobile: "",
				State: "",
			},
			//apiObj: this.$API.demo.page,
			params: {
				name: "demoName",
			},
			personvalue: "",
			props: {
				label: "AName",
				value: "Code",
				keyword: "keyword",
				selectKeyValue: { type: String, default: "Code2" },
			},
			
		};
	},
	computed: {},
	mounted() {},
	methods: {
		//值变化
		change(val) {
			
			//debugger;
			/*
			console.log(val);
			let userCode = tool.data.get("USER_INFO").UserCode;
			if (userCode == "admin" || userCode == "super")
				this.$emit("fatherMethod", val);
			else {
				if (Array.isArray(val)) {
					if (val.length == 0) {
						this.$alert("请选择要操作的机构", "提示", {
							type: "warn",
						});
						this.$emit("fatherMethod", []);
					} else this.$emit("fatherMethod", val);
				} else {
					if (val) {
						this.$emit("fatherMethod", val);
					}
				}
			}
			//this.$message("change事件，返回详情查看控制台1");
			*/
			this.personvalue = val.Code;
		},
	},
};
</script>

<style scoped></style>
